<template>
  <mdb-container style="margin-top: 6em">
    <section class="text-justify text-monospace my-5">
      <h2 class="h1-responsive font-weight-bold my-5 text-center">塞浦路斯护照移民</h2>
      <p class="w-responsive mx-auto mb-5">
        <span class="mr-4"></span>
        塞浦路斯共和国位于欧洲与亚洲交界处，属于亚热带地中海气候，有着“欧洲阳台”的美称，是全球著名的度假养老圣地。作为发达的资本主义国家，塞浦路斯早在2004年就已经加入欧盟，企业所得税仅10%，为欧盟最低，还与全球40多个国家签订了避免双重征税的协议。宜人的居住环境和广阔的投资空间，让塞浦路斯吸引了全球投资者的目光。
      </p>
      <mdb-row class="">
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/cy/1.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请要求</h4>
            <h5>主申请人</h5>
            <p>1.主申请人年满18周岁；</p>
            <p>2.在塞浦路斯境内购买价值200万欧元及以上的住宅房产，捐款15万欧元；
              或投资250万欧元于塞浦路斯商业和住宅房产，需包含一套价值50万欧元及以上的自住房产；
            </p>
            <p>3.房产3年后可出售，只需保留价值50万欧元的自住房产即可；</p>
            <p>4.需提供无犯罪证明。</p>
            <h5>附属申请人：</h5>
            <p> 1.配偶；</p>
            <p> 2.28周岁以下在读且经济不独立的子女；</p>
            <p> 3.主申请人父母。</p>
          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/cy/2.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">项目优势</h4>
            <p>1、欧盟福利——可在含欧盟成员在内的31个国家自由居住、学习，享公民福利</p>
            <p>2、教育福利——子女可在欧盟成员国内任意国家接受教育，直通英美国际名校</p>
            <p>3、畅行全球——免签欧盟成员国、加拿大、日本等173个国家和地区，便捷出行</p>
            <p>4、税务规划——企业所得税12.5%，无遗产税、财产税，无全球征税，无外汇管制，规避CRS风险</p>
          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/cy/3.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请流程</h4>
            <p>1、与嘉诚海外签约</p>
            <p>2、准备首次入境签证文件和移民申请文件</p>
            <p>3、实地考察并购买房产/国内订房</p>
            <p>4、完成购房手续</p>
            <p>5、律师向内政部递交移民申请材料</p>
            <p>6、录取指纹</p>
            <p>7、获发塞浦路斯永居卡</p>
            <p>8、获得护照批复函</p>
            <p>9、登陆塞浦路斯宣誓，获得护照</p>

          </mdb-card-body>
        </mdb-col>
      </mdb-row>
    </section>
  </mdb-container>
</template>

<script>
  export default {
    name: 'Cy'
  }
</script>

<style scoped>

</style>
